module.exports = __webpack_public_path__ + "static/img/rating-S.c7c2d13.png";